import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserManager } from '../../auth/user-manager';
import { AuthUserService } from '../../init/auth-user.service';

@Component({
  selector: 'app-main-sidebar',
  templateUrl: './main-sidebar.component.html',
  styleUrls: ['./main-sidebar.component.less'],
  standalone: false
})
export class MainSidebarComponent implements OnInit, AfterViewInit {

  @Output()
  onViewInit: EventEmitter<any> = new EventEmitter();

  username: string = '';

  modeloAso: FormGroup = new FormGroup({
    nome: new FormControl('')
  });

  constructor(private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authUserService: AuthUserService) {
    if (this.authUserService.isAnonymous) {
      this.username = 'Visitante';
    } else {
      const user = this.authUserService.getCurrentUser();
      this.username = (!user.isAnonymous ? user.username : null)
        ?? UserManager.getUserInfo()?.username
        ?? 'Usuário';
    }
  }

  get isAcademicStaff(): boolean {
    return true;//***testes*/
    //const user = this.authUserService.getCurrentUser();
    //return !user.isAnonymous && user.isAcademicStaff;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.onViewInit.emit();

    /*Sentry.getFeedback()?.attachTo(document.querySelector('#feedback-button')!, {
      isEmailRequired: true,
      isNameRequired: true,
      triggerLabel: "Relatar um Bug",
      formTitle: "Relatar um Bug",
      submitButtonLabel: "Enviar Relatório de Bug",
      cancelButtonLabel: "Cancelar",
      confirmButtonLabel: "Confirmar",
      addScreenshotButtonLabel: "Adicionar uma captura de tela",
      removeScreenshotButtonLabel: "Remover captura de tela",
      nameLabel: "Nome",
      namePlaceholder: "Seu Nome",
      emailLabel: "Email",
      emailPlaceholder: "seu.email@exemplo.org",
      isRequiredLabel: "(obrigatório)",
      messageLabel: "Descrição",
      messagePlaceholder: "Qual é o bug? O que você esperava?",
      successMessageText: "Obrigado pelo seu relatório!"
    })*/
  }
}
